import { createFileRoute } from "@tanstack/react-router";
import { DenomLandingPage } from "@/components/prize-bond/DenomLandingPage";
import { buildPrizeBondLandingHead } from "@/lib/prize-bond-landing-head";

const DENOM = 750;
const SLUG = "prize-bond-list-750-today";
const TITLE =
  "Prize Bond List 750 Today 2026 - Prize Bond Check Karne Ka Tarika - Check Prize Bond Online";
const DESC =
  "Rs. 750 prize bond list today — latest draw ka full winners list Pakistan. Single, bulk aur range online checker with official National Savings data.";

const HOW_TO_STEPS = [
  { title: "Rs. 750 select karein", body: "Upar checker mein pehle se 750 select hai — agar nahi to Rs. 750 wali chip par tap karein." },
  { title: "Bond number likhein", body: "Apna 6-digit bond number input mein type karein — jaise 234567. Bulk mein 100 tak ek saath check ho sakte hain." },
  { title: "Check karein", body: "Green 'Check Karain' button dabayein. Winners green highlight ho jate hain, non-winners neeche list mein aa jate hain." },
  { title: "Result verify karein", body: "Winning bond ki draw #, city aur inaam amount card par likha hoga — National Savings PDF se cross-check bhi kar sakte hain." },
  { title: "Prize claim karein", body: "Jeetne par 6 saal ke andar CNIC copy, bond original aur withholding tax proof le kar SBP Banking Services branch mein jama karayein." },
];

const FAQS = [
  { q: "Rs. 750 prize bond ki full list aaj kahan milegi?", a: "Draw hone ke 24 hours ke andar upar checker par pehli, doosri aur teesri position wale numbers show ho jate hain. Poori 1696-winner PDF National Savings ki website savings.gov.pk par bhi publish hoti hai — hamara data usi source se update hota hai." },
  { q: "750 prize bond ka pehla inaam kitna hai 2026 mein?", a: "First prize Rs. 15,00,000 (15 lakh) — 1 winner. Second prize Rs. 5,00,000 (5 lakh) — 3 winners. Third prize Rs. 9,300 — 1,696 winners. Total prize pool har draw mein ~Rs. 3.1 crore." },
  { q: "Prize bond 750 today ka draw kis city mein hua?", a: "Rs. 750 draw quarterly hota hai — rotation mein Karachi, Lahore, Multan, Peshawar, Rawalpindi, Muzaffarabad, Faisalabad aur Quetta shamil hain. Checker card par draw city aur draw number dono milte hain." },
  { q: "Kya main 750 bond ki purani draws bhi check kar sakta hoon?", a: "Haan — jab bhi aap bond number check karte hain, system saari uploaded draws ke against match run karta hai. Agar puraani draw mein bhi jeeta ho to sab winning entries alag alag cards mein aati hain." },
  { q: "750 wala prize bond kahan se milta hai?", a: "SBP Banking Services aur authorized commercial banks (HBL, MCB, UBL, ABL, NBP) ke branches se cash par bearer form mein milta hai — koi CNIC copy ya form nahi bharna parta chotay denomination ke liye." },
  { q: "Aik person maximum kitne Rs. 750 bonds rakh sakta hai?", a: "Rs. 750 bearer bond hai — koi upper limit nahi. Sirf Rs. 40,000 premium bond par filer-only aur registration rules lagu hain, chotay bonds sab ke liye open hain." },
  { q: "Rs. 750 par kitna tax katega jeetne par?", a: "Filer ke liye 15% withholding tax aur non-filer ke liye 30% — sirf tabhi jab prize Rs. 5,000 se upar ho. Matlab agar sirf third prize Rs. 9,300 jeeta to filer ko Rs. 1,395 tax katke Rs. 7,905 net milega." },
  { q: "Kya online 750 prize bond checker safe hai?", a: "Haan — hum sirf bond number match karte hain, koi CNIC, phone ya identity data collect nahi karte. Bulk aur range check bhi anonymous hain aur numbers server par store nahi hote." },
  { q: "750 prize bond draw kab kab hoti hai saal mein?", a: "Saal mein 4 draws — usually January, April, July aur October ke pehle hafte mein. Exact date National Savings 15 din pehle official calendar par announce karta hai." },
  { q: "Agar bond gum ho jaye to kya karein?", a: "FIR darj karayein, doosre din ek Urdu aur ek English newspaper mein classified advertisement dein, phir 6 mahine wait period ke baad SBP branch se duplicate bond issue ho jata hai — indemnity bond ke saath." },
];

const RELATED = [
  { href: "/prize-bond-100-result-today", label: "Rs. 100 Prize Bond" },
  { href: "/prize-bond-200-result-today", label: "Rs. 200 Prize Bond" },
  { href: "/prize-bond-1500-result-today", label: "Rs. 1,500 Prize Bond" },
  { href: "/prize-bond-25000-result-today", label: "Rs. 25,000 Premium" },
  { href: "/prize-bond-40000-result-today", label: "Rs. 40,000 Premium" },
  { href: "/prize-bond", label: "All Prize Bonds Hub" },
];

export const Route = createFileRoute("/prize-bond-list-750-today")({
  head: () =>
    buildPrizeBondLandingHead({
      slug: SLUG,
      title: TITLE,
      description: DESC,
      denomination: DENOM,
      howToName: "How to check Rs. 750 Prize Bond list today",
      howToSteps: HOW_TO_STEPS,
      faqs: FAQS,
    }),
  component: Page,
});

function Page() {
  return (
    <DenomLandingPage
      denomination={DENOM}
      h1English="Prize Bond List 750 Today — Full Draw Result & Online Checker"
      h1Hinglish="750 Wale Prize Bond Ki List Aaj — Ek Click Mein Check Karain"
      introParagraphs={[
        "Rs. 750 Pakistan ka sab se popular mid-range prize bond hai — sasta bhi hai aur first prize Rs. 15 lakh tak deta hai, isi liye har chothay ghar mein rakha hota hai. Is page par aap seedha aaj ki draw ke against apne 750 wale bonds check kar sakte hain — chahe ek number ho, 100 numbers ho ya poori serial range.",
        "Data source National Savings Pakistan (savings.gov.pk) hai. Draw complete hote hi hum official winners PDF parse karke checker mein feed karte hain, isliye aap ko koi list PDF download karke Ctrl+F search karne ki zarurat nahi rehti — bulk mein 100 aur range mein 500 tak numbers ek click mein clear ho jate hain.",
        "Neeche checker ke baad Rs. 750 bond ki prize breakdown, tax calculation, claim process aur unique FAQs bhi diye hain jo Pakistan mein sab se zyada search hote hain.",
      ]}
      keyFacts={[
        { label: "1st Prize", value: "Rs. 15,00,000" },
        { label: "2nd Prize (×3)", value: "Rs. 5,00,000" },
        { label: "3rd Prize (×1696)", value: "Rs. 9,300" },
        { label: "Draw Frequency", value: "Har 3 mahine" },
      ]}
      sections={[
        {
          id: "prize-breakdown",
          heading: "Rs. 750 Prize Bond — Full Prize Structure",
          body: (
            <>
              <p>
                Har draw mein total 1,700 winners nikalte hain. Pehla inaam Rs. 15 lakh sirf ek lucky number ko milta hai —
                yehi wo jackpot hai jis ke liye log Rs. 750 wala bond rakhte hain. Doosra inaam Rs. 5 lakh 3 winners mein
                distribute hota hai, aur teesra inaam Rs. 9,300 poore Pakistan mein 1,696 log jeette hain — matlab har draw
                mein 750 wale bond par jeetne ka realistic chance khaasa acha hai.
              </p>
              <p>
                Agar aapke paas 20 bonds bhi hain to statistically har 2 saal mein kam se kam ek chota inaam milne ke
                chances hain — isi liye 750 ko "starter jackpot bond" bhi kehte hain.
              </p>
            </>
          ),
        },
        {
          id: "tax-and-claim",
          heading: "Tax, Claim aur Deadline",
          body: (
            <>
              <p>
                Rs. 5,000 se upar ke prize par withholding tax lagta hai — filer ke liye 15%, non-filer ke liye 30%.
                Third prize Rs. 9,300 par filer ko net Rs. 7,905 aur non-filer ko Rs. 6,510 milta hai. Jeetne ke baad
                claim ki deadline draw ki tareekh se 6 saal hai — usse pehle SBP Banking Services Corporation branch
                mein original bond, CNIC copy aur claim form jama karayein. Bara inaam (Rs. 5 lakh+) cross cheque
                account mein deposit hota hai.
              </p>
            </>
          ),
        },
      ]}
      howToSteps={HOW_TO_STEPS}
      faqs={FAQS}
      relatedLinks={RELATED}
    />
  );
}
